import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Languages } from "lucide-react";
import { api } from "@/lib/api";

export function EntityWords({ ent }) {
  const navigate = useNavigate();
  const { data: words = [] } = useQuery({ queryKey: ["entity-words", ent.id], queryFn: () => api.get(`/entities/${ent.id}/words`).then((r) => r.data) });
  if (!words.length) return null;
  const base = window.location.pathname.split("/").slice(0, 3).join("/");
  return (
    <section className="mt-8" data-testid="entity-words">
      <div className="lf-label mb-3">Words in languages</div>
      <div className="flex flex-wrap gap-2">
        {words.map((w) => (
          <button key={w.id} onClick={() => navigate(`${base}/languages/${w.language_id}`)} data-testid={`entity-word-${w.id}`}
            className="flex items-center gap-2 rounded-sm border border-[#14B8A6]/40 px-3 py-1.5 text-sm text-[#E8DFD1] transition-colors hover:border-[#14B8A6]">
            <Languages className="h-3.5 w-3.5 text-[#14B8A6]" /><span className="font-display text-base">{w.word}</span><span className="text-xs text-[#A8A090]">{w.language_name}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
